import { Button, Divider, Popover, Space, Typography, prefixCls } from "@payping/web-components";
import { InfoCircleFilled, InfoCircleOutlined, SyncOutlined } from "@payping/icons";
import { useAppTranslation } from "@/utils";
import { selectAtom } from "jotai/utils";
import { dashboardPreferencesAtom } from "@/core/state";
import { useAtom } from "jotai";

const serviceWorkerAtom = selectAtom(dashboardPreferencesAtom, (val) => val.serviceWorker);
const appVersionAtom = selectAtom(dashboardPreferencesAtom, (val) => val.appVersion);
export const Update = () => {
  const [serviceWorker] = useAtom(serviceWorkerAtom);
  const [appVersion] = useAtom(appVersionAtom);
  const { t } = useAppTranslation();

  return serviceWorker?.hasUpdate ? (
    <Popover
      overlayClassName={`${prefixCls}-web-mainNav-update`}
      placement={"bottomLeft"}
      content={
        <div>
          <div className={`${prefixCls}-web-mainNav-update-versionRow`}>
            <Space className={"tw-items-baseline"}>
              <SyncOutlined width={14} />
              <Typography.Title level={5} className={"tw-font-normal"}>
                {t("version.newVersion")}
              </Typography.Title>
            </Space>
            <span className="!tw-dir-ltr">{appVersion.latest}</span>
          </div>
          <Divider className={`${prefixCls}-web-mainNav-update-divider`} />
          <div className={`${prefixCls}-web-mainNav-update-versionRow`}>
            <Space className={"tw-items-baseline"}>
              <InfoCircleFilled width={14} className={"color--warning"} />
              <Typography.Title level={5} className={"tw-font-normal"}>
                {t("version.currentVersion")}
              </Typography.Title>
            </Space>

            <span className={"color--warning !tw-dir-ltr"}>{appVersion.current}</span>
          </div>
          <Divider className={`${prefixCls}-web-mainNav-update-divider`} />
          <Space className={"tw-items-baseline"}>
            <InfoCircleOutlined width={14} className={"color--cta"} />
            <Typography.Title level={5} className={"tw-font-normal"}>
              {t("version.updateProcess.title")}
            </Typography.Title>
          </Space>

          <Typography.Paragraph className={"tw-px-4"}>{t("version.updateProcess.description")}</Typography.Paragraph>
          <Divider className={`${prefixCls}-web-mainNav-update-divider`} />
          <Button>{t("showMore")}</Button>
        </div>
      }
    >
      <Button type={"primary"} icon={<SyncOutlined width={14} height={14} />}>
        {t("version.update")}
      </Button>
    </Popover>
  ) : null;
};
